var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"22","y1":"2","x2":"11","y2":"13","key":0}),React.createElement("polygon",{"points":"22 2 15 22 11 13 2 9 22 2","key":1})]);
}

Email.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Email;

Email.default = Email;
